import { useRef, useEffect } from 'react';

import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import SwiperCore from 'swiper';
import { DynamicComponent } from 'ui';
import Slider from 'ui/components/Slider';
import SectionObserver from 'ui/layouts/SectionObserver';
import { capitalize } from 'utils/string';
import { classNameType, colorType } from 'utils/types';

import s from './StickyHeader.module.scss';

const cx = cn.bind(s);

const StickyHeader = ({
  items, active = '', color, isDense = false, className, setActive, ...attrs
}) => {
  const slider = useRef();

  useEffect(() => {
    if (active) {
      const indexToSet = items.findIndex((item) => item.title === active || item.key === active);
      if (indexToSet !== -1 && slider.current) {
        slider.current.setSlide(indexToSet);
      }
    }
  }, [active, items]);
  return !!items.length && (
    <div
      className={cx('header', className, { [`swiper-scroll-color--${color}`]: color })}
      {...attrs}
    >
      <Slider
        className={cx('slider', 'swiper-auto-width')}
        slidesPerView="auto"
        spaceBetween={0}
        freeMode={true}
        scrollbar={true}
        pagination={false}
        ref={slider}
      >
        {items.map((item) => (
          <DynamicComponent
            tag={SectionObserver.Link}
            key={item}
            href={item.href}
            name={item.key || item.title}
            className={cx('item', color, {
              activeItem: active === item.title || active === item.key,
              denseItem: isDense,
            })}
          >
            {capitalize(item.menuTitle || item.title)}
          </DynamicComponent>
        ))}
      </Slider>
    </div>
  );
};

StickyHeader.propTypes = {
  className: classNameType,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ),
  color: colorType,
  active: PropTypes.string,
  isDense: PropTypes.bool,
};

export default StickyHeader;
